package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ComedyMaskW500Rounded: ImageVector
    get() {
        if (_comedyMaskW500Rounded != null) {
            return _comedyMaskW500Rounded!!
        }
        _comedyMaskW500Rounded = Builder(name = "ComedyMaskW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(587.85f, 646.86f)
                quadToRelative(45.93f, -39.84f, 56.13f, -99.27f)
                quadToRelative(2.24f, -11.2f, -5.22f, -19.27f)
                quadToRelative(-7.46f, -8.08f, -19.65f, -8.08f)
                lineTo(340.89f, 520.24f)
                quadToRelative(-11.43f, 0.0f, -19.15f, 8.08f)
                quadToRelative(-7.72f, 8.07f, -5.72f, 19.27f)
                quadToRelative(10.2f, 59.43f, 56.13f, 99.27f)
                quadTo(418.09f, 686.7f, 480.0f, 686.7f)
                reflectiveQuadToRelative(107.85f, -39.84f)
                close()
                moveTo(480.0f, 888.13f)
                quadToRelative(-76.67f, 0.0f, -143.61f, -29.1f)
                quadToRelative(-66.93f, -29.1f, -116.63f, -78.67f)
                quadToRelative(-49.69f, -49.58f, -78.79f, -116.63f)
                quadToRelative(-29.1f, -67.06f, -29.1f, -143.49f)
                verticalLineToRelative(-357.37f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                horizontalLineToRelative(554.26f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(357.37f)
                quadToRelative(0.0f, 76.43f, -29.1f, 143.49f)
                quadToRelative(-29.1f, 67.05f, -78.79f, 116.63f)
                quadToRelative(-49.7f, 49.57f, -116.75f, 78.67f)
                quadToRelative(-67.06f, 29.1f, -143.49f, 29.1f)
                close()
                moveTo(480.0f, 797.13f)
                quadToRelative(115.04f, 0.0f, 196.09f, -80.92f)
                quadToRelative(81.04f, -80.93f, 81.04f, -195.97f)
                verticalLineToRelative(-357.37f)
                lineTo(202.87f, 162.87f)
                verticalLineToRelative(357.37f)
                quadToRelative(0.0f, 115.04f, 81.04f, 195.97f)
                quadToRelative(81.05f, 80.92f, 196.09f, 80.92f)
                close()
                moveTo(480.0f, 480.0f)
                close()
                moveTo(308.55f, 290.02f)
                quadToRelative(-21.81f, 16.48f, -30.53f, 41.68f)
                quadToRelative(-3.48f, 10.19f, 3.36f, 18.77f)
                quadToRelative(6.84f, 8.57f, 19.27f, 8.57f)
                lineTo(417.2f, 359.04f)
                quadToRelative(11.43f, 0.0f, 18.39f, -8.57f)
                quadToRelative(6.95f, -8.58f, 4.24f, -18.77f)
                quadToRelative(-8.72f, -25.2f, -30.66f, -41.68f)
                quadToRelative(-21.93f, -16.48f, -50.37f, -16.48f)
                quadToRelative(-28.43f, 0.0f, -50.25f, 16.48f)
                close()
                moveTo(550.59f, 290.02f)
                quadToRelative(-21.94f, 16.48f, -30.66f, 41.68f)
                quadToRelative(-3.47f, 10.19f, 3.36f, 18.77f)
                quadToRelative(6.84f, 8.57f, 19.28f, 8.57f)
                horizontalLineToRelative(116.78f)
                quadToRelative(11.43f, 0.0f, 18.39f, -8.57f)
                quadToRelative(6.96f, -8.58f, 4.24f, -18.77f)
                quadToRelative(-8.72f, -25.2f, -30.65f, -41.68f)
                quadToRelative(-21.94f, -16.48f, -50.37f, -16.48f)
                quadToRelative(-28.44f, 0.0f, -50.37f, 16.48f)
                close()
            }
        }
        .build()
        return _comedyMaskW500Rounded!!
    }

private var _comedyMaskW500Rounded: ImageVector? = null
